import React from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ title, items = [] }) => {
  return (
    <div className="d-flex flex-wrap align-items-center justify-content-end gap-3 mb-3">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-0" style={{ fontSize: "14px" }}>
          <li className="breadcrumb-item">
            <Link
              to="/Dashboard"
              className="d-flex align-items-center gap-1 text-muted text-decoration-none"
              style={{ fontSize: "13px" }}
            >
              <Icon
                icon="solar:home-smile-angle-outline"
                className="icon"
                style={{ fontSize: "14px" }}
              />
              Pagmus
            </Link>
          </li>
          {items &&
            items.map((item, index) => (
              <li key={index} className="breadcrumb-item">
                {item.path ? (
                  <Link
                    to={item.path}
                    className="text-muted text-decoration-none"
                    style={{ fontSize: "13px" }}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-muted" style={{ fontSize: "13px" }}>
                    {item.label}
                  </span>
                )}
              </li>
            ))}
          <li
            className="breadcrumb-item text-muted active"
            aria-current="page"
            style={{ fontSize: "13px" }}
          >
            {title}
          </li>
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
